import { useAuth } from '@clerk/clerk-react'
import { createApi } from '../lib/api'
import { useMemo } from 'react'

export function useApi() {
  const { getToken } = useAuth()
  return useMemo(() => createApi(() => getToken()), [getToken])
}
